import * as React from "react";
import { cn } from "../../lib/utils";

/**
 * Ladeplatzhalter für Batch-Lookups (Foods/Purchases/Rezepte). Ersetzt "leere"
 * Zustände in non-suspending/suspending Lookup-Konsumenten, damit ein Ladestand
 * nie wie fehlende Daten aussieht.
 *
 * Die `data-cy` wird für E2E-Tests durchgereicht (z. B. "cooking-step-loading").
 */
export function LookupSkeleton(props: {
  className?: string;
  dataCy?: string;
  lines?: number;
}) {
  const lines = props.lines ?? 1;
  return (
    <span
      data-cy={props.dataCy}
      role="status"
      aria-label="Lädt"
      className={cn("flex w-full flex-col gap-1.5", props.className)}
    >
      {Array.from({ length: lines }).map((_, index) => (
        <span
          key={index}
          className="block h-3 w-full animate-pulse rounded-xs bg-ink/10"
        />
      ))}
    </span>
  );
}
